var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBtcv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34156 10.085L12.0055 5.42112L16.6694 10.085L19.38 7.37449L11.9945 0L4.631 7.37449L7.34156 10.085ZM0 11.9945L2.71056 9.28395L5.42112 11.9945L2.71056 14.7051L0 11.9945ZM7.34156 13.915L12.0055 18.5789L16.6694 13.915L19.38 16.6255L12.0055 24L4.631 16.6255L7.34156 13.915ZM18.5789 12.0055L21.2894 9.28395L24 11.9945L21.2894 14.7161L18.5789 12.0055Z",
    fill: "#C89C65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7497 11.9952L11.9952 9.24072L9.96501 11.2709L9.73456 11.5014L9.25171 11.9842L12.0062 14.7387L14.7497 11.9952Z",
    fill: "#C89C65"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBtcv);
export default __webpack_public_path__ + "static/media/icon_btcv.e0e7347a.svg";
export { ForwardRef as ReactComponent };